import { registerEvaroConnect } from './evaro-connect'
import { registerEvaroLanding } from './evaro-landing'
import { bootstrapAnalytics } from './analytics-bridge'
import { setLoaderOrigin } from './config'

/**
 * The origin this loader script was served from. Landings default their CDN to
 * it — loader.js and the `/v2/` manifests are always co-deployed, so "fetch
 * manifests from wherever the loader came from" needs no configuration.
 */
function detectLoaderOrigin(): string | null {
  if (typeof document === 'undefined') return null
  const tag = document.currentScript as HTMLScriptElement | null
  if (!tag?.src) return null
  try {
    return new URL(tag.src).origin
  } catch {
    return null
  }
}

interface ScriptDataset {
  vendor?: string
  template?: string
  category?: string
  cdn?: string
  apiBase?: string
  env?: string
}

function autoBootstrapFromScriptTag(): void {
  if (typeof document === 'undefined') return

  const tag = (document.currentScript as HTMLScriptElement | null)
    ?? document.querySelector<HTMLScriptElement>('script[data-vendor][data-template]')

  if (!tag) return

  const ds = tag.dataset as ScriptDataset
  if (!ds.vendor || !ds.template) return

  // Dedup against an already-mounted element. The category is part of the
  // identity: two scripts may share a vendor + template and differ only by
  // category, and both should mount.
  const categorySelector = ds.category ? `[category="${ds.category}"]` : ''
  if (document.querySelector(`evaro-landing[vendor="${ds.vendor}"][template="${ds.template}"]${categorySelector}`)) {
    return
  }

  const placeholder = document.getElementById('evaro-landing')
  const anchor: ParentNode | null = placeholder ?? tag.parentNode

  if (!anchor) return

  const el = document.createElement('evaro-landing')
  el.setAttribute('vendor', ds.vendor)
  el.setAttribute('template', ds.template)
  if (ds.category) el.setAttribute('category', ds.category)
  if (ds.cdn) el.setAttribute('cdn', ds.cdn)
  if (ds.apiBase) el.setAttribute('api-base', ds.apiBase)
  if (ds.env) el.setAttribute('env', ds.env)

  if (placeholder) {
    placeholder.replaceWith(el)
  } else {
    anchor.appendChild(el)
  }

  bootstrapAnalytics({ vendorHash: ds.vendor, apiBase: ds.apiBase, env: ds.env })
}

setLoaderOrigin(detectLoaderOrigin())
registerEvaroConnect()
registerEvaroLanding()
autoBootstrapFromScriptTag()
